// src/components/Footer.js

import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Clínica Ciudad - San Rafael. Todos los derechos reservados.</p>
    </footer>
  );
};

export default Footer;